<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: ['arrayData'],
  data() {
    return {
      gradient: null,
      gradient2: null,
      // summary: this.arrayData,
    };
  },
  mounted() {
    console.log(this.summary)
    this.gradient = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 450);
    this.gradient2 = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 450);

    this.gradient.addColorStop(0, "rgba(255, 0,0, 0.5)");
    this.gradient.addColorStop(0.5, "rgba(255, 0, 0, 0.25)");
    this.gradient.addColorStop(1, "rgba(255, 0, 0, 0)");

    this.gradient2.addColorStop(0, "rgba(0, 231, 255, 0.9)");
    this.gradient2.addColorStop(0.5, "rgba(0, 231, 255, 0.25)");
    this.gradient2.addColorStop(1, "rgba(0, 231, 255, 0)");
      // {
      //   labels: [
      //     "January",
      //     "February",
      //     "March",
      //     "April",
      //     "May",
      //     "June",
      //     "July"
      //   ],
      //   datasets: [
      //     {
      //       label: "Data One",
      //       borderColor: "#FC2525",
      //       pointBackgroundColor: "white",
      //       borderWidth: 1,
      //       pointBorderColor: "white",
      //       backgroundColor: this.gradient,
      //       data: [40, 39, 10, 40, 39, 80, 40]
      //     },
      //     {
      //       label: "Data Two",
      //       borderColor: "#05CBE1",
      //       pointBackgroundColor: "white",
      //       pointBorderColor: "white",
      //       borderWidth: 1,
      //       backgroundColor: this.gradient2,
      //       data: [60, 55, 32, 10, 2, 12, 53]
      //     }
      //   ]
      // },
      // { responsive: true, maintainAspectRatio: false }
    // );
    let labels = []
    let data1 = []
    let data2 = []

    this.summary.forEach(element => {
      labels.push(element.PRODUCTO)
      data1.push(element.UTCOP)
      data2.push(element.UTCTVUSD)
    });
    this.renderChart(
      {
        labels: labels,
        datasets: [
          {
            label: "UT COP",
            borderColor: "#FC2525",
            pointBackgroundColor: "brown",
            borderWidth: 1,
            pointBorderColor: "white",
            backgroundColor: this.gradient,
            data: data1
          },
          {
            label: "UT CTV USD",
            borderColor: "#05CBE1",
            pointBackgroundColor: "blue",
            pointBorderColor: "white",
            borderWidth: 1,
            backgroundColor: this.gradient2,
            data: data2
          }
        ]
      },
      { responsive: true, maintainAspectRatio: false }
    );
  },
  computed: {
    summary(){
      return this.arrayData
    }
  },
  updated(){
    let labels = []
    let data1 = []
    let data2 = []

    this.summary.forEach(element => {
      labels.push(element.PRODUCTO)
      data1.push(element.UTCOP)
      data2.push(element.UTCTVUSD)
    });
    this.renderChart(
      {
        labels: labels,
        datasets: [
          {
            label: "UT COP",
            borderColor: "#FC2525",
            pointBackgroundColor: "brown",
            borderWidth: 1,
            pointBorderColor: "white",
            backgroundColor: this.gradient,
            data: data1
          },
          {
            label: "UT CTV USD",
            borderColor: "#05CBE1",
            pointBackgroundColor: "blue",
            pointBorderColor: "white",
            borderWidth: 1,
            backgroundColor: this.gradient2,
            data: data2
          }
        ]
      },
      { responsive: true, maintainAspectRatio: false }
    );
  }

};
</script>
